document.addEventListener('DOMContentLoaded', function() {

    const highlighted_checkboxes = document.querySelectorAll('.edit-menu-item-highlighted');

    highlighted_checkboxes.forEach(highlighted_checkbox => {
        // console.log(highlighted_checkbox);
        const elementToToggle = highlighted_checkbox.closest('.bw-mega-menu-additional').querySelector('.highlighted-link-text');
        // console.log(elementToToggle);
        if (highlighted_checkbox.checked) {
            elementToToggle.classList.remove('hidden');
        } else {
            elementToToggle.classList.add('hidden');
        }

        highlighted_checkbox.addEventListener('change', function() {
            if (this.checked) {
                elementToToggle.classList.remove('hidden');
            } else {
                elementToToggle.classList.add('hidden');
            }
        });
    });

    // Media library "Select" button click handler
    document.addEventListener('click', function(e) {
        if(!e.target.matches('.upload-menu-item-image')){
            return;  
        }
        e.preventDefault();

        const button = e.target;
        const menu_item_image = button.previousElementSibling;
        // const menu_item_image_id = menu_item_image.id.replace('edit-menu-item-image-', '');

        // Create and open the media library frame
        const media_frame = wp.media.frames.media_frame = wp.media({
            title: 'Select or Upload Media for Image',
            button: {
                text: 'Use this media'
            },
            multiple: false
        });

        // Media library "Select" button click handler
        media_frame.on('select', function() {
            const media_attachment = media_frame.state().get('selection').first().toJSON();

            // Update the image input field value
            // console.log(media_attachment);
            menu_item_image.value = media_attachment.url;
        });

        // Open the media library frame
        media_frame.open();
    });
});
